import { Box, Container, Typography, Paper } from '@mui/material';

const PressPage = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h2" 
          component="h1" 
          align="center" 
          gutterBottom
          sx={{ 
            fontWeight: 700, 
            mb: 4,
            fontSize: { xs: '2rem', md: '2.5rem' }
          }}
        >
          Press Releases
        </Typography>
        
        <Typography 
          variant="subtitle1" 
          align="center" 
          sx={{ mb: 6, maxWidth: '800px', mx: 'auto' }}
        >
          Stay informed with the latest news and updates from Recruitment Intelligence. Explore our press releases for insights into our innovations, partnerships, and industry impact.  
        </Typography>
        
        <Paper 
          elevation={3} 
          sx={{ 
            width: '100%', 
            height: '800px', 
            overflow: 'hidden',
            borderRadius: 2,
            mb: 4
          }}
        >
          <Typography
            variant="subtitle1"
            align="center"
            sx={{
              p: 4,
              color: 'text.secondary',
              fontStyle: 'italic'
            }}
          >
            Our press releases are currently under development. Please check back soon for updates.
          </Typography>
 {/*          <Box 
            component="iframe" 
            src="https://www2.jobdiva.com/portal/?a=1ujdnwrj39gls9ed4gpig5qubccjya0667r01d9ye4g9h6pns1hg6zcttrtk1l33#/"
            title="Recruitment Intelligence Careers" 
            sx={{ 
              width: '100%', 
              height: '100%', 
              border: 'none' 
            }} 
          /> */}
        </Paper>
        
        <Typography variant="body2" align="center" sx={{ mt: 2, color: 'text.secondary' }}>
          Can't find what you're looking for? Email us at <Box component="span" sx={{ color: 'primary.main' }}>info@recruitmentintelligence.com</Box>
        </Typography>
      </Container>
    </Box>
  );
};

export default PressPage;
